//src/pages/reports/ReportsRootLayout.tsx
import { Outlet } from "react-router-dom";
export default function ReportsRootLayout() {
  return (
    <div style={{ padding: 24 }}>
      <Outlet /> {/* mostrará el sub-layout de cada categoría */}
    </div>
  );
}
